<i inlineSVG="{{ iconPath }}.svg"></i>
